import { IGradeCompany, ITARank } from "@types";

export const getRows = (
  taRanks: ITARank[] = [],
  companies: IGradeCompany[] = []
) => {
  const data: any[] = [];
  const companies_ranks: Record<string, any[]> = {};

  companies.forEach(company => {
    companies_ranks[company.name.replace(/\s/g, "")] =
      company.grade_company_ranks ?? [];
  });

  taRanks.forEach((rank, index) => {
    const row: any = { rank: rank.rank };

    Object.keys(companies_ranks).forEach(key => {
      row[key] = companies_ranks[key][index]?.grades?.join(", ") || "";
    });

    data.push(row);
  });

  return data;
};
